import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { ShareLinkFormType } from '../link-config-form.factory';
import { SharePanelFormSection } from './section';

const SharePanelFormAccessSectionLink = () => {
  const {
    values: { allowed_emails, blacklisted_emails, email_required, email_verification, nda_required, password, expires_at },
  } = useFormikContext<ShareLinkFormType>();

  const subtitle: string = useMemo(() => {
    let subtitleBlocks: string[] = [];
    if (email_required) {
      subtitleBlocks.push('email required');
    }
    if (email_verification) {
      subtitleBlocks.push('verification required');
    }
    if (nda_required) {
      subtitleBlocks.push('NDA required');
    }
    if (allowed_emails && allowed_emails.length) {
      subtitleBlocks.push('whitelist');
    }
    if (blacklisted_emails && blacklisted_emails.length) {
      subtitleBlocks.push('blacklist');
    }
    if (password) {
      subtitleBlocks.push('password protected');
    }
    if (expires_at) {
      subtitleBlocks.push('expiration date');
    }
    const subtitleStr = subtitleBlocks.length ? `${subtitleBlocks.join(', ')}.` : 'Control access to this Journey';
    return `${subtitleStr.charAt(0).toUpperCase()}${subtitleStr.slice(1)}`;
  }, [allowed_emails, blacklisted_emails, email_required, email_verification, nda_required, expires_at, password]);

  return <SharePanelFormSection type='access' title='Access' subTitle={subtitle} />;
};

export default SharePanelFormAccessSectionLink;
